import React, { useContext, useEffect, useRef, useState } from "react";
import BannerSection from "./BannerSection";
import FeatureList from "./FeatureList";
import CategoryGrid from "./CategoryGrid";
import HotDeals from "./HotDeals";
import WhyAriha from "./WhyAriha";
import Testimonials from "./Testimonials";
// import BlogList from './BlogList';
// import LogoCarousel from './LogoCarousel';
import "./Home.css";
import slides1 from "../../../assets/images/slide1.png";
import slides2 from "../../../assets/images/slide2.png";
import slides3 from "../../../assets/images/slide3.png";
// import { getAllProducts, getAllPosts } from './postService';
import { useNavigate } from "react-router-dom";
import { Swiper } from "swiper/react";
import { SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Button, Container } from "react-bootstrap";
// import 'swiper/css';
import "swiper/css/navigation";
import PostApiCall from "../helper/PostAPI";
import { newstore } from "./Pages/Store/newStore";
import GetSeoData from "../../Helpers/GetSeoData";

function Home() {
  const { cartItems } = useContext(newstore);
  const [productdet, setProductdet] = useState([]);
  const navRef = useRef(null);
  const [navHeight, setNavHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const recentProductdet = [...productdet]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(1, 7);
  const [addedItems, setAddedItems] = useState(new Set());
  // const { addToCart } = useCart();
  const [selectedProduct, setSelectedProduct] = useState(null);
  // const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();
  // const recentBlogs = [...blogs]
  //   .sort((a, b) => new Date(b.date) - new Date(a.date))
  //   .slice(0, 12);

  useEffect(() => {
    // PostApiCall.postRequest(
    //   {
    //     categoryid: null,
    //     orderid: 0,
    //   },
    //   "getFoodMenuOrder"
    // ).then((results) =>
    //   results.json().then((data) => {
    //     if (results.status === 200 || results.status === 201) {
    //       setProductdet(data.message);
    //       if (data.message.length > 0) {
    //         setSelectedProduct(data.message[0]);
    //       }
    //     }
    //   })
    // );
    PostApiCall.postRequest(
      {
        stateid: null,
      },
      "Get_All_Items"
    )
      // PostApiCall.postRequest({}, "GetAllItems")
      .then((results) =>
        results.json().then((data) => {
          if (results.status === 200 || results.status === 201) {
            setProductdet(data.data);
            if (data.data.length > 0) {
              setSelectedProduct(data.data[0]);
            }
          }
        })
      );
  }, []);

  useEffect(() => {
    if (!navRef.current) return;

    const observer = new ResizeObserver(([entry]) => {
      setNavHeight(entry.contentRect.height);
    });

    observer.observe(navRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleAddprod = (item) => {
    // addToCart(item);
    setAddedItems((prev) => new Set(prev).add(item._id));
    setTimeout(() => {
      setAddedItems((prev) => {
        const updated = new Set(prev);
        updated.delete(item._id);
        return updated;
      });
    }, 3000);
  };

  const imgpath = "http://localhost:5000";

  return (
    <>
      <GetSeoData type="Home" />
      {/* <Header  /> */}
      <div
        style={{
          marginTop: isMobile ? `${navHeight}px` : `${navHeight + 40}px`,
        }}>
        <BannerSection />
      </div>
      <FeatureList />
      <CategoryGrid />
      <HotDeals
        selectedProduct={selectedProduct}
        setSelectedProduct={setSelectedProduct}
        recentProductdet={recentProductdet}
        handleAddprod={handleAddprod}
        addedItems={addedItems}
        imgpath={imgpath}
      />
      <Container>
        <Swiper
          // slidesPerView={3}
          breakpoints={{
            768: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          spaceBetween={30}
          navigation={true}
          modules={[Navigation]}
          className="mySwiper">
          <SwiperSlide>
            <img
              src={slides1}
              alt="Slide 1"
              onClick={() => navigate("/shop")}
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={slides2}
              alt="Slide 2"
              onClick={() => navigate("/shop")}
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={slides3}
              alt="Slide 3"
              onClick={() => navigate("/shop")}
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={slides1}
              alt="Slide 1"
              onClick={() => navigate("/shop")}
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={slides2}
              alt="Slide 2"
              onClick={() => navigate("/shop")}
            />
          </SwiperSlide>
          <SwiperSlide>
            <img
              src={slides3}
              alt="Slide 3"
              onClick={() => navigate("/shop")}
            />
          </SwiperSlide>
        </Swiper>
      </Container>
      <WhyAriha />
      <Testimonials />

      <section className="content-wrapper">
        <div className="container">
          <div className="row">
            <div className="content-wrapper-list">
              <h1>Ariha Foods – A Premium Bakery Brand in Chennai</h1>

              <p>
                As a well-known online bakery shop in Chennai, Ariha Foods
                delivers freshly baked products that stand out for their taste,
                texture, and hygiene. We baked premium{" "}
                <a href="https://arihafoods.com/category/breads">breads</a>,
                <a href="https://arihafoods.com/category/brownies"> brownies</a>
                ,{" "}
                <a href="https://arihafoods.com/category/chocolate-confectionery">
                  {" "}
                  chocolate confectionery
                </a>
                , and{" "}
                <a href="https://arihafoods.com/category/cookies"> cookies</a>.
                Each product is prepared using quality ingredients and monitored
                processes to ensure freshness from production to delivery. Our
                dedication to food safety and freshness allows us to offer
                healthy & fresh bakery products in Chennai that meet the daily
                needs of families, cafés, and food businesses.
              </p>
              <h2>Trusted Bakery Products Manufacturer in Chennai</h2>
              <p>
                Ariha Foods is a leading Chennai bakery product manufacturer,
                baking a diverse range of bakery items with a focus on uniform
                quality and longer shelf life. Our manufacturing setup follows
                industry-approved standards, enabling us to handle bulk
                production without compromising on taste or consistency. This
                makes Ariha Foods a preferred manufacturing partner for
                wholesalers, retailers, and food service providers across
                Chennai.
              </p>
              <h2>Buy Bakery Products Online with Ease</h2>
              <p>
                Through Ariha Foods Bakery Online, customers can conveniently
                buy bakery products online with complete confidence in quality
                and freshness. Our online ordering system is designed to be
                simple and efficient, allowing easy access to premium bakery
                products with reliable delivery timelines. Whether ordering for
                home consumption or business needs, order Bakery Online ensures
                a smooth and dependable purchasing experience.
              </p>
              <h2>Same day Bakery Delivery in Chennai</h2>
              <p>
                At Ariha Foods, we offer a wide range of freshly prepared bakery
                items made using quality ingredients and hygienic baking
                processes. Our bakery products include daily essentials and
                specialty treats, carefully baked to deliver freshness, taste,
                and consistency. With online bakery delivery in Chennai,
                customers can conveniently order their favourite bakery products
                from the comfort of their home or business location.
              </p>
              <p>
                Our selection includes fresh bread and loaves, multigrain and
                brown bread, cakes, brownies, cookies, and chocolate-based
                bakery products. We also provide health-focused options such as
                sugar-free and low GI bakery items to meet modern dietary needs.
                To ensure maximum convenience, we offer same day bakery delivery
                across Chennai, making it easy to enjoy fresh bakery products
                whenever you need them.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="fixed-bottom mb-0 ms-auto px-2">
        <div>
          <>
            <div className="d-flex flex-wrap flex-lg-nowrap justify-content-end align-items-center py-2">
              {cartItems?.length > 0 && (
                <Button
                  variant="danger"
                  size="lg"
                  className={
                    cartItems?.length > 0
                      ? "floating-button-cart floating-button-cart-btn d-flex"
                      : "floating-button-cart d-flex"
                  }
                  onClick={() => {
                    navigate("/cart");
                  }}>
                  <div>
                    <p className="mb-0 total-item-amount d-flex">
                      {cartItems?.length} Item
                      <span
                        style={{
                          display: cartItems?.length == 1 ? "none" : "block",
                        }}>
                        (s)
                      </span>
                      &nbsp; | ₹ {cartItems[0]?.fld_cart_amount_no_shipping}{" "}
                      Plus Taxes
                    </p>
                  </div>
                </Button>
              )}
            </div>
          </>
        </div>
      </section>
      {/* <BlogList recentBlogs={recentBlogs} handleReadMore={handleReadMore} /> */}
      {/* <LogoCarousel /> */}
    </>
  );
}

export default Home;
